import Actions from 'Redux/Actions';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";
import { OrganizerRepository } from 'Domain/Repositories';
import { message }              from 'antd';

export const createOrganizerEpic: TEpic = (action$) => {
    return action$.pipe(
        ofType(Actions.createOrganizerRequest.type),
        mergeMap(action => from(OrganizerRepository.create( action.payload.formData ))
            .pipe(
                mergeMap((organizer) => {
                  message.success('Organisator wurde erfolgreich erstellt');
                  return from([
                      Actions.createOrganizerSuccess({ organizer })
                    ]);
                }),
                catchError( error => {
                    return from([
                      Actions.createOrganizerFailure({ error }),
                    ])
                })
            )
        ),
    );
}
